/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Image, Text, Pressable } from '@components/atoms'
import { Footer } from '@components/systems'
import event1Img from '@public/images/pages/event/event1.gif'
import event2Img from '@public/images/pages/event/event2.jpg'
import event3Img from '@public/images/pages/event/event3.gif'
import event4Img from '@public/images/pages/event/event4.gif'

import { useNavigate } from 'react-router-dom'
import { grey } from '@mui/material/colors'

const EventPage = () => {
	// hook
	const navigate = useNavigate()

	return (
		<View css={style}>
			<View className="mainView">
				<View className="mainBgView">
					<Image src={event1Img} className="mainImage" />
				</View>
				<View className="mainBgView">
					<Image src={event2Img} className="mainImage" />
				</View>
				<View className="mainBgView">
					<Image src={event3Img} className="mainImage" />
				</View>
				<View className="mainBgView">
					<Image src={event4Img} className="mainImage" />
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default EventPage

const style = css({
	position: 'relative',
	width: '100%',

	'.mainView': {
		width: '100%',
		borderBottom: '1px solid',
		borderColor: grey[900],

		'.mainBgView': {
			position: 'relative',
			display: 'flex',
			width: '100%',
			height: 'fit-content',
			overflow: 'hidden',

			'.mainImage': {
				width: '100%',
				height: 'auto',
				margin: 'auto',
				left: 0,
				right: 0,
				bottom: 0,
			},
		},
	},
})
